import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Navigation",
    component: () => require("./navigation-view")
});

export default definition;
